import { ReactNode } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { useSidebar } from '../../../hooks/useSidebar'
import { SidebarType } from '../../../types/Sidebar'
import { BookingFormValues } from '../../../types/BookingForm'
import { toEditFormValues } from '../../../utils/bookingForm'

import { SidebarStateBookingEdit } from '@/types/SidebarStates'

const BookingEditForm = ({
  booking,
  children,
}: {
  booking: SidebarStateBookingEdit['booking']
  children: ReactNode
}) => {
  const methods = useForm<BookingFormValues>({
    defaultValues: toEditFormValues(booking),
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}

const BookingEditFormProvider = ({ children }: { children: ReactNode }) => {
  const { sidebar } = useSidebar()

  if (!sidebar.open || sidebar.type !== SidebarType.BOOKING_EDIT) return <>{children}</>

  const { booking } = sidebar as SidebarStateBookingEdit

  // Keyed by id: opening another booking resets the form, a state change on the same one doesn't.
  return (
    <BookingEditForm key={booking.id} booking={booking}>
      {children}
    </BookingEditForm>
  )
}

export default BookingEditFormProvider
